import Button from '@/components/base/Button';
import Reveal from '@/components/base/Reveal';

export default function FounderSection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-28 bg-background-50">
      <div className="max-w-content mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <Reveal className="order-2 lg:order-1">
          <span className="font-label text-xs uppercase tracking-widest2 text-primary-400">
            The Founder
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl leading-tight text-foreground-950">
            Meet Daniella — The Heart Behind KOR38
          </h2>
          <div className="mt-6 space-y-4 text-base leading-relaxed text-foreground-700">
            <p>
              &ldquo;I&rsquo;m Daniella, a hairdresser, session stylist and the founder of KOR38.
              Throughout my career in London, I&rsquo;ve worked with talented creatives, industry
              professionals and VIP clients. What I&rsquo;ve valued most are the relationships built
              along the way.
            </p>
            <p>
              Over the years, people came to me for much more than hairdressing — asking for
              recommendations, advice and introductions to people I know and trust. I realised that
              connecting people was something I genuinely loved doing. That&rsquo;s how KOR38 was born.
              Today, I&rsquo;m bringing that personal approach to helping people find the right suppliers
              and specialists for their events. My philosophy is simple: listen carefully, recommend
              honestly, and connect thoughtfully.&rdquo;
            </p>
          </div>
          <div className="mt-8">
            <Button to="/about" variant="outline" size="lg">
              Read Daniella&rsquo;s Story
            </Button>
          </div>
        </Reveal>

        <Reveal delay={120} className="order-1 lg:order-2">
          <div className="relative w-full aspect-[4/5] max-w-md mx-auto overflow-hidden rounded-lg border border-background-200">
            <img
              src="https://storage.helloreaddy.io/project_files/70bd3036-f013-4766-9098-d293cc2afad4/054d0577-a2d9-4221-b3e4-558c384fd3f1_compressed_Centred-Professional-Blonde-Business-Headshot.webp"
              alt="Daniella Farrell, founder of KOR38"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}